<template>
  <v-card>
    <v-card-title>
      Sold Out Products
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        class="pt-0"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-btn
        @click.prevent="csvExport(csvData)"
        class="ml-3"
      >Export CSV</v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="notifications"
      :rows-per-page-items="rowsPerPageItems"
      v-bind:pagination.sync="pagination"
      :search="search"
      :loading="isLoading"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.email }}</td>
          <td class="text-xs-right">{{ props.item.product_id }}</td>
          <td class="text-xs-right">{{ props.item.product_title }}</td>
          <td class="text-xs-right">{{ props.item.product_price }}</td>
          <td class="text-xs-right">{{ props.item.product_type }}</td>
          <td class="text-xs-right">{{ props.item.product_vendor }}</td>
          <td class="text-xs-right">
            <v-chip v-if="props.item.is_resolved" color="primary" class="m-0" text-color="white">Resolved</v-chip>
            <v-chip v-else class="m-0">Pending</v-chip>
          </td>
          <td class="text-xs-right">{{ props.item.created_at | time }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import moment from 'moment-timezone';
export default {
  metaInfo () {
    return { title: 'Dashboard' }
  },
  middleware: 'auth',
  data: () => ({
    notifications: [],
    headers: [
      { text: 'Email', align: 'left', value: 'email' },
      { text: 'Product Id', align: 'right', value: 'product_id' },
      { text: 'Product Title', align: 'right', value: 'product_title' },
      { text: 'Product Price', align: 'right', value: 'product_price' },
      { text: 'Product Type', align: 'right', value: 'product_type' },
      { text: 'Product Vendor', align: 'right', value: 'product_vendor' },
      { text: 'State', align: 'right', value: 'state' },
      { text: 'Created At', align: 'right', value: 'created_at' }
    ],
    rowsPerPageItems: [10,25,50,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
    pagination: {'sortBy': 'created_at', 'descending': true, 'rowsPerPage': 10},
    search: '',
    isLoading: false
  }),
  mounted() {
    this.fetchNotifications();
  },
  methods: {
    async fetchNotifications() {
      this.isLoading = true;
      axios
        .get('/api/notify-me')
        .then((response) => {
          let data = response.data;

          this.notifications = data.notifications;
          this.isLoading = false;
        }, (error) => {
          console.error(error.response.data.message);
          this.isLoading = false;
        });
    },
    csvExport(arrData) {
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map(item => Object.values(item).join(","))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "notications.csv");
      link.click();
    }
  },
  computed: {
    csvData() {
      return this.notifications.map(item => ({
        "Email": item.email,
        "Product Id": item.product_id,
        "Product Title": item.product_title,
        "Product Price": item.product_price,
        "Product Type": item.product_type,
        "Product Vendor": item.product_vendor,
        "State": item.is_resolved ? 'resolved' : 'pending',
        "Created At": item.created_at,
      }));
    }
  },
  filters: {
    time: function (value) {
      if (!value)
        return '';

      return moment.tz(value, window.config.timezone).tz('America/Toronto').format("YYYY-MM-DD HH:mm:ss");
    }
  },
}
</script>

<style>
  .v-chip .v-chip__content {
    height: 24px;
  }

  .v-datatable tbody tr {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// resources/js/pages/sold-out-products.vue